import styled from 'styled-components';

export const StyledDataContentPaymentsElement = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 8px;
`;
